/*
    Description: js video (youtube) library page class
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/

// import utilities
import Utilities from "./utilities";

// video class
class Videos extends Utilities{

    // constructor
    constructor({

        // video section
        videoSection = "videos",

        // video list wrapper
        videoWrapperClass = "videos__list",
        
        // video element wrapper
        videoItemClass = "videos__list__card",

        // get DOM search box element
        showMoreBttnClass = "--js-load-videos",

        // search button class name
        // searchBttnClass = "--js-search-videos", 
        closeBttn = "--js-search-videos-close",

        // reverse list class name
        reverseListClass = "--video-list-reverse",

        // search term input field
        searchInput = "videos__search__wrapper__search",

        // get search nonce id name
        searchNonceID = "videos__search__wrapper__nonce",

        // response wrapper
        responseWrapper = "videos__search__wrapper__response",

        //nonce label
        nonceID = "vid-library",

        // click area
        clickArea = "videos__search__gui",

        // global loading gif
        loadingClass = "--loading",

        // global hide class
        hideClass = "--hide"
        
    }={}){

        // get constructor/params from Utilities
        super();

        // set video section
        this.videosClass = videoSection;

        // init list of all the videos we have in our channel
        this.allVideos = [];

        // set loading class
        this.loading = loadingClass;

        // set hide class
        this.hide = hideClass;

        // response wrapper
        this.responseWrapper = responseWrapper;

        // get nonce label
        this.nonceID = nonceID;

        // search input class name
        this.searchInputClass = searchInput;

        // get search nonce id
        this.searchNonceID = searchNonceID;

        // set selector
        this.bttnClassName = showMoreBttnClass;

        // search button class
        // this.searchBttnClassName = searchBttnClass;
        this.close = closeBttn;

        // set selector
        this.videoItemName = videoItemClass;
        
        // set wrapper selector
        this.videoWrapperName = videoWrapperClass;

        // reverse class name
        this.reverse = reverseListClass;
        
        // get video section
        this.videos = document.querySelector(`.${this.videosClass}`);

        // get wrapper element
        this.wrapper = document.querySelector(`.${this.videoWrapperName}`);

        // get all video items on screen
        this.videoCards = document.querySelectorAll(`.${this.videoItemName}`);

        // response wrapper
        this.response = document.querySelector(`.${this.responseWrapper}`);

        // get nonce 
        this.nonce = document.getElementById(`${this.nonceID}`);

        // get element
        this.searchInput = document.querySelector(`.${this.searchInputClass}`);
        
        // get search nonce 
        this.searchNonce = document.getElementById(`${this.searchNonceID}`);

        // get element
        this.bttn = document.querySelector(`.${this.bttnClassName}`);

        // get search bttn element
        this.closeBttn = document.querySelector(`.${this.close}`);

        // get total videos
        this.totalVideos = (this.bttn && this.bttn.dataset) ? this.bttn.dataset.total : 0;

        // current video count
        this.currentCount = (this.videoCards) ? this.videoCards.length : 0;

        // click area
        this.clickArea = clickArea;

        // youtube api call switch
        this.apiCalled = false;

        // min characters before search performed
        this.min = 3;

        // fire off events -- pass a few elements
        this.events();

    }

    // fire off all events
    events(){

        // set this to self
        const that = this;

        // chech for close bttn
        if(that.closeBttn){

            // close button
            that.closeBttn.addEventListener("click", (e) => {
                
                // prevent default 
                e.preventDefault();

                // exit
                that.exitSearch();
            
            });

        }

        // check if we can click outside
        if(document.body){

            // add event to videos selector
            document.body.addEventListener("click", function(e){

                // get outside click area
                const area = document.querySelector(`.${that.clickArea}`);
                
                // make sure we have area
                if(area){
                    
                    // check if area clicked outside
                    if(!area.contains(e.target)){
    
                        // exit method
                        that.exitSearch();
    
                    }
                    
                }
    
            });

        }

        // we have videos to show
        if(that.currentCount < that.totalVideos){

            // add click event listener 
            if(that.bttn){

                // show more button
                that.bttn.classList.remove(that.hide);

                // add event listener
                that.bttn.addEventListener('click', that.moreVideos.bind(that)); 

            } 
            
        }

        // check if we have searchInput
        if(that.searchInput){

            // add key event
            that.searchInput.addEventListener('keyup', that.keyPressed.bind(that));

        }

        // DOM ready state complete 
        that.domReady(function(){
            
            // load sources
            that.loadSources();
        
        });

        // setup scroll behavior
        document.addEventListener("scroll", that.searchBoxPosition.bind(that));

    }

    // key event
    keyPressed(e){

        // call search
        this.getSearchList(e);

        // if escape was pressed exit and cleanup
        if(e.key.toLowerCase() === "escape"){

            // exit search
            this.exitSearch();

        }

    }

    // DOM ready check
    domReady(callback){

        // make sure callback is a function
        if(typeof callback !== 'function') throw new Error('Error: Callback needs to be a function.');
        
        // if not loading
        if(document.readyState != 'loading'){
            
            // call back
            callback();
        
        // fire off listener
        }else if(document.addEventListener){
            
            // boolean to remove event after checking once
            document.addEventListener('DOMContentLoaded', callback, { once:true });

        // default
        }else{

            // check state
            document.attachEvent('onreadystatechange', function(){
            
                // fire off callback
                if(document.readyState != 'loading') callback();

            });

        }

    }

    // set results position
    searchBoxPosition(){
    
        // get the ul result list
        const response = (this.response) ? this.response.querySelector("ul") : null,

        // get the search input field
        searchInput = (this.searchInput) ? this.searchInput : null;

        // check for resultBox
        if(response){
            
            // calculate scroll position
            const scrollPosition = document.body.scrollTop, 
            
            // get input field position
            inputFieldPosition = searchInput.getBoundingClientRect().top,
            
            // get input field relative position
            relativePosition = (inputFieldPosition - scrollPosition),

            // get half of the window height
            winHeight = (window.innerHeight/2);

            // update class
            (relativePosition > winHeight) ? response.classList.add(this.reverse) :  response.classList.remove(this.reverse);

        }

    }

    // get more videos
    moreVideos(e){

        // prevent default click behavior
        e.preventDefault();

        // add loading gif
        this.bttn.classList.add(this.loading); 

        // setup data
        const data = new FormData();

        // get total videos
        data.append("totalVideos", this.totalVideos);
        
        // get total videos
        data.append("nextToken", ((this.bttn.dataset.next)? this.bttn.dataset.next : null));
        
        // make sure we have data
        if(this.nonce) data.append("wp_nonce", this.nonce.value);

        // send ajax
        this.ajax({
            action:"moreVideos",
            loading:this.bttn,
            data:data
        // success
        }).then((results) => {

            //parse results
            results = JSON.parse(results);

            // ERROR: die silently - but remove button
            if(results.error){
                
                //display msg
                for(const key in results.error) {
                    if(Object.hasOwnProperty.call(results.error, key)){
                        console.log(`%c ${results.error[key]}`, 'background:#f00; color:#fff');            
                    }
                }

                // remove button
                this.bttn.remove();

                //return
                return
                
            };

            // check for wrapper and tags
            if(this.wrapper && results.tags){

                // add results as html elements
                this.wrapper.insertAdjacentHTML("beforeend", results.tags);

                // load iframe srcs
                this.loadSources();

            }

            // check for API next token
            if(this.bttn.dataset.next && results.token){

                // pass token to data set
                this.bttn.dataset.next = results.token;

            // token is missing -- usually means we have no more videos
            }else{

                // remove "show more button"
                this.bttn.remove();

            }

        // catch ajax error
        }).catch((err) => {
            
            //display msg
            console.log(`%c ${err}`, 'background:#f00; color:#fff');

        });

    }

    // for optimization load all videos after page load
    loadSources(){

        // pass this to self
        const that = this;

        // get all video wrappers
        const videoWrappers = document.querySelectorAll(`.${this.videoItemName}`);

        // loop thru video wrappers
        for(const video of videoWrappers){
            
            // get iframe
            const iframe = video.querySelector("iframe.--loading");

            // make sure we have an iframe that is loading
            if(iframe){

                // get data value
                const dataValue = iframe.getAttribute("data-src");

                // set src of iframe to data value
                if(dataValue){

                    // remove loading gif
                    iframe.setAttribute("src", dataValue);

                    // remove loading class
                    (window.addEventListener) ? iframe.addEventListener("load", function(){iframe.classList.remove(that.loading);}, true) : iframe.attachEvent("onload", function(){iframe.classList.remove(that.loading);});

                } 

            }

        }

    }

    // get all channel videos and populate it into our array
    getSearchList(e){

        // prevent default
        // e.preventDefault();
        
        // init data
        const videoCount = this.allVideos.length,
            searchTerm = (this.searchInput) ? this.searchInput.value : document.querySelector(`.${this.searchInputClass}`).value;

        // make sure we have at least min characters
        if(searchTerm.length < this.min) return;

        // remove hide class and add loading gif
        this.closeBttn.classList.remove(this.hide);
        this.closeBttn.classList.add(this.loading);

        // we already have a list
        if(videoCount > 0){

            // empty search error
            if(!searchTerm || searchTerm.trim() == "") return this.errorMsg("A search term is required. Please try again.");

            // do a search
            return this.searchList(searchTerm);

        }

        // switch api
        this.apiCalled = true;

        // init data
        const searchNonce = (this.searchNonce) ? this.searchNonce.value : null,
            data = new FormData();

        // get total videos
        data.append("nonce", searchNonce);

        // send ajax
        this.ajax({
            action:"getVideoList",
            loading:this.closeBttn,
            data:data
        // success
        }).then((results) => {
            
            //parse results
            results = JSON.parse(results);
            
            // SUCCESS: results
            if(results){
                
                // error msg
                if(results.error) return this.errorMsg(results.error);

                // pass data to our array
                this.allVideos = results;

                // empty search
                if(!searchTerm || searchTerm.trim() == "") return this.errorMsg("A search term is required. Please try again.");
                
                // do a search
                this.searchList(searchTerm);
                
            // ERROR: show error msg
            }else{

                // ERROR: return search error msg from AJAX
                this.errorMsg(`We couldn't find a match for "${terms}". Please try again.`);

            } 

            // reset api
            this.apiCalled = false;

        // catch ajax error
        }).catch((err) => {
            
            //display msg
            console.log(`%c ${err}`, 'background:#f00; color:#fff');

        });
        
    }

    // search list
    searchList(terms){

        // init vars
        const searchArray = terms.toLowerCase().split(" "),
            searchResults = [];

        // loop thru search terms 
        searchArray.map((term) => {

            // get cleaned up term
            const cleanTerm = term.trim();
            
            // LOOP: thru video files
            for(const key in this.allVideos){

                // get title
                const title = (this.allVideos[key]["snippet"] && this.allVideos[key]["snippet"]["title"]) ? this.allVideos[key]["snippet"]["title"] : null,
                    videoID = (this.allVideos[key]["snippet"] && this.allVideos[key]["snippet"]["resourceId"]) ? this.allVideos[key]["snippet"]["resourceId"]["videoId"] : null;

                // check if we have a title and we get a match
                if(cleanTerm && (title.toLowerCase().indexOf(cleanTerm) > -1)){

                    // push results to our results array
                    searchResults.push([
                        title,
                        videoID
                    ]);

                }
                
            }

        });      

        // NO RESULTS: check results
        if(searchResults.length < 1){

            // ERROR: return search error msg 
            this.errorMsg(`We couldn't find a match for "${terms}". Please try again.`);

        // RESULTSshow list
        }else{

            // show results
            this.successResults(searchResults);

        }

        // remove loading gif
        // this.searchBttn.classList.remove(this.loading);

        // return
        return;

    }

    // error response block
    errorMsg(copy){

        // remove loading gif
        // this.searchBttn.classList.remove(this.loading);
        if(this.closeBttn) this.closeBttn.classList.remove(this.loading);

        // reset response wrapper
        this.response.innerHTML = "";

        // create p tag
        const p = document.createElement("p");

        // add class
        p.classList.add("videos__search__wrapper__response__error", "--error");

        //add copy
        p.textContent = copy;

        //add DOM
        return this.response.appendChild(p);

    }

    // add results to response block
    successResults(results){
        
        // remove loading gif
        if(this.closeBttn) this.closeBttn.classList.remove(this.loading);
        
        // reset response wrapper
        this.response.innerHTML = "";

        // the results array was empty
        if(!results || (results.length < 1)) return this.errorMsg("Your search did not match any results. Please try again.");

        // create ul tag
        const ul = document.createElement("ul");

        // add class
        ul.classList.add("videos__search__wrapper__response__ul", "--search-shadow");

        // LOOP: build out li list based on our results
        results.forEach((video) => {

            // create li element
            const li = document.createElement("li"),
                a = document.createElement("a");

            // add classes
            li.classList.add("videos__search__wrapper__response__ul__li");
            a.classList.add("videos__search__wrapper__response__ul__li__a");

            // set anchor attributes
            a.setAttribute("href", `https://www.youtube.com/watch?v=${video[1]}`);
            a.setAttribute("title", `Click here to watch ${video[0]}`);
            a.setAttribute("aria-label", `Click here to watch ${video[0]}`);
            a.setAttribute("target", "_blank");
            a.setAttribute("tabindex", "0");
            a.textContent = video[0];
            
            // add anchor to li
            li.appendChild(a);

            // add li to ul
            ul.appendChild(li);

        });

        //add ul DOM
        return this.response.appendChild(ul);

    }

    // exitclose everything
    exitSearch(){
        
        // check if we have a close button
        if(this.closeBttn){
            
            // remove loading gif
            this.closeBttn.classList.remove(this.loading);

            // hide close button
            this.closeBttn.classList.add(this.hide);
            
        }

        // reset response wrapper
        if(this.response) this.response.innerHTML = "";

        // clear input
        if(this.searchInput) this.searchInput.value = "";

    }

}


// export
export default Videos;